import Model from './Model'

export default class TemplateTitle extends Model {
  id: number
  title: string

  constructor(json, locale) {
    super({})
    this.id = json.id
    this.title = this.translateField(json._title, locale)
  }
}
